import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faGraduationCap, faFileSignature, faStar, faStarHalfAlt, faUsers} from "@fortawesome/free-solid-svg-icons";
import {faStar as faStarRegular } from "@fortawesome/free-regular-svg-icons";
import frFlag from '../fr.svg';
import FormattedMoney from "./FormattedMoney";
import {formatDuration} from "../util";

const StarIcon = ({ note, index }) => {
    const lowerLimit = (index + 1) - .75;
    const halfLimit = (index + 1) - .25;

    if (note < lowerLimit) {
        return <FontAwesomeIcon icon={faStarRegular} />;
    } else if (lowerLimit <= note && note < halfLimit) {
        return <FontAwesomeIcon icon={faStarHalfAlt} />;
    } else if (halfLimit <= note) {
        return <FontAwesomeIcon icon={faStar} />;
    }

    return null;
};

const Hit = ({ hit }) => {
    return (
        <div className="formation formation-list">
            <div className="wrapper">
                <div className="col">
                    <div className="formation-domaine">
                        <span className="hint--bottom" aria-label="Domaine de rattachement">{hit.domain}</span>
                        {' | '}
                        {hit.formacode && (
                            <>
                                <span className="formation-formacode">
                                    <span className="hint--bottom" aria-label="Formacode">{hit.formacode}</span>
                                </span>
                                {' | '}
                            </>
                        )}
                        {hit.subdomain && (
                            <>
                                <span className="formation-subdomain">
                                    <span className="hint--bottom" aria-label="Sous-domaine">{hit.subdomain}</span>
                                </span>
                                {' | '}
                            </>
                        )}
                        <span className="formation-reference">
                            <span className="hint--bottom" aria-label="Référence interne">#{hit.code}</span>
                        </span>
                    </div>
                    <h2 className="formation-title">
                        {hit.name}
                    </h2>
                    {hit.score > 0 && (
                        <div className="formation-note">
                            {[...Array(5)].map((e, index) => (
                                <StarIcon key={index} index={index} note={hit.score} />
                            ))}
                            {' '}
                            <small>
                                {(hit.score % 1 === 0)
                                    ? parseFloat(hit.score).toFixed(0)
                                    : parseFloat(hit.score).toFixed(1)
                                } /5
                            </small>
                        </div>
                    )}
                    <div className="formation-details">
                        <div className="wrapper">
                            <span className="item formation-participants hint--bottom" aria-label="Nombres de participants : min-max">
                                <FontAwesomeIcon icon={faUsers} />
                                &nbsp;
                                {hit.minimumCapacity}-{hit.maximumCapacity}
                            </span>
                            {' | '}
                            <span className="item formation-langue hint--top" aria-label="Langue d'enseignement">
                                <img src={frFlag} alt="" />
                            </span>
                            {(hit.mode && hit.mode.length > 0) && (
                                <>
                                    {' | '}
                                    <span className="item formation-modalite hint--top" aria-label="Modalité d’organisation">
                                        {hit.mode.map((mode, index) => {
                                            if (!mode) {
                                                return null;
                                            }

                                            if (index === 0) {
                                                return mode;
                                            }

                                            return ', ' + mode;
                                        })}
                                    </span>
                                </>
                            )}
                        </div>
                    </div>
                </div>
                <div className="col">
                    <div className="formation-duree">
                        {('' !== hit.durationHours && null !== hit.durationHours) ? formatDuration(hit.durationHours, 'heure', 'heures') : ''}
                        {('' !== hit.durationDays && null !== hit.durationDays) ? (
                            <small>{formatDuration(hit.durationDays, 'jour', 'jours')}</small>
                        ) : ''}
                    </div>
                </div>
                <div className="col">
                    <div className="item">
                        {hit.postTrainingResultIndicators && (
                            <div className="formation-cqp hint--top" aria-label="Attestation de suivi de formation">
                                <FontAwesomeIcon icon={faFileSignature} className="fa-w-18"/>
                            </div>
                        )}
                        {(hit.rncp || hit.rs) && (
                            <div className="formation-cqp hint--top" aria-label="Certificat">
                                <FontAwesomeIcon icon={faGraduationCap} className="fa-w-20"/>
                            </div>
                        )}
                        <div className="formation-criteres-prise-charge">
                            {hit.cpf && (
                                <span className="item hint--top" aria-label="Compte personnel de formation">CPF</span>
                            )}
                            {(hit.rncp || hit.rs) && (
                                <>
                                    {' '}<span className="item hint--top" aria-label="Reconversion ou promotion par l'alternance">PRO A</span>
                                </>
                            )}
                            {hit.pdc && (
                                <>
                                    {' '}<span className="item hint--top" aria-label="Plan de développement des compétences">PDC</span>
                                </>
                            )}
                        </div>
                    </div>
                    <div className="formation-price">
                        <div className="hint--top" aria-label="Cout € HT TVA 20%">
                            {hit.intra && (
                                <>
                                    Intra : <FormattedMoney amount={hit.priceIntra} />&nbsp;HT&nbsp;/&nbsp;jour
                                </>
                            )}

                            {(hit.inter && hit.intra) && <br />}

                            {hit.inter && (
                                <>
                                    Inter : <FormattedMoney amount={hit.priceInter} />&nbsp;HT&nbsp;/&nbsp;stagiaire
                                </>
                            )}

                            <br />
                            <a href={hit.contactUsUrl} target="_blank">
                                <small>Sur-mesure ? Contactez-nous !</small>
                            </a>
                        </div>
                    </div>
                </div>
                <a href={hit.url} target="_blank" className="formation-link">Ouvrir dans un nouvel onglet</a>
            </div>
        </div>
    );
};

export default Hit;
